import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IState } from 'models/reducers/i-state.interface';

import { setShowSelectWalletModal, setShowSwitchNetworkModal } from 'actions/global-actions';

export const useWalletConnection = () => {
  const dispatch = useDispatch();

  const walletAddress = useSelector((state: IState) => state.wallet.address);
  const { correctChain } = useSelector((state: IState) => state.web3);

  const isConnected = Boolean(walletAddress);

  const connectWallet = useCallback(() => {
    dispatch(setShowSelectWalletModal(true));
  }, [dispatch]);

  const switchNetwork = useCallback(() => {
    dispatch(setShowSwitchNetworkModal(true));
  }, [dispatch]);

  return {
    isConnected,
    address: walletAddress || null,
    isCorrectChain: correctChain || false,
    connectWallet,
    switchNetwork,
  };
};
